import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogCloseButton,
  AlertDialogContent, AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay, Button, useDisclosure,
} from '@chakra-ui/react';
import { FaTrash } from 'react-icons/fa';
import React, { useImperativeHandle, useRef } from 'react';

interface AlterProps {
  onConfirm: () => void;
  message: string;
}
// eslint-disable-next-line react/prop-types
const Alert = React.forwardRef<any, AlterProps>(({ message, onConfirm }, ref) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  useImperativeHandle(ref, () => ({
    onOpen: () => {
      onOpen();
    },
  }));
  const cancelRef = useRef(null);
  return (
    <>
      <AlertDialog
        isOpen={isOpen}
        onClose={onClose}
        leastDestructiveRef={cancelRef}
        isCentered
      >
        <AlertDialogOverlay />
        <AlertDialogContent>
          <AlertDialogHeader>Are You Sure?</AlertDialogHeader>
          <AlertDialogCloseButton />
          <AlertDialogBody>
            {message}
          </AlertDialogBody>
          <AlertDialogFooter>
            <Button
              variant="danger"
              leftIcon={<FaTrash />}
              onClick={() => {
                onConfirm();
                onClose();
              }}
            >
              Yes
            </Button>
            <Button
              ref={cancelRef}
              onClick={onClose}
              ml={3}
            >
              No
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
});
export default Alert;
